<template>
    <div class="message-send-mdn">
        <div v-if="message.mdn.sent === false">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{Language.say('messages.open.mdn.requested')}}</span>
            <span v-if="!loading"
              @click="onSendReceipt()"
              role="button"
            >{{Language.say('messages.open.mdn.send')}}
          </span>
          <span v-else>
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </div>
        <div v-else>
            <i class="far fa-check-circle"></i>
            <span>{{Language.say('messages.open.mdn.sent')}}</span>
            <span>{{message.recipients.from.email}}</span>
        </div>
    </div>
</template>

<script setup>
  import {ref}         from 'vue';
  import {defineProps} from 'vue';
  import Language      from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    viewport_controller: {
      required: true,
    },

    folder_id : {
      required: true,
    },

    message : {
      required : true,
    },

  })

  const loading = ref(false);

  const onSendReceipt = async () => {
    loading.value = true;
    await props.viewport_controller.sendMDNReceipt(props.folder_id, props.message.id);
    loading.value = false;
  }

</script>
